import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkState } from './types';

export const createAppAsyncThunk = createAsyncThunk.withTypes<ThunkState>();

export const getTypedThunk = <Returned, arg = {}>() =>
  createAppAsyncThunk<Returned, arg>;
